import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

const ScaleIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 50 50" {...props}>
      <path
        d="M43.6828 4.77428C38.4242 2.02901 31.9723 0.412109 25 0.412109C18.0276 0.412109 11.5757 2.02901 6.31718 4.77428C1.86184 7.10024 -0.62729 11.9957 0.136694 16.9631L3.7703 40.5905C4.56637 45.7668 9.02019 49.5882 14.2574 49.5882H35.7426C40.9799 49.5882 45.4337 45.7669 46.2297 40.5905L49.8633 16.9631C50.6272 11.9957 48.1381 7.10024 43.6828 4.77428Z"
        fill="#FFDAAA"
      />
      <path
        d="M38.2802 25.584H11.7201C9.15949 25.584 7.20134 27.8663 7.59047 30.3972L9.03363 39.7814C9.43303 42.378 11.6303 44.2632 14.2578 44.2632H35.7424C38.37 44.2632 40.5671 42.3779 40.9665 39.7814L42.4097 30.3972C42.799 27.8663 40.8409 25.584 38.2802 25.584Z"
        fill="#F7931E"
      />
      <path
        d="M36.6508 7.56576C33.0428 6.36274 29.0917 5.73779 24.9999 5.73779C20.908 5.73779 16.9568 6.36274 13.349 7.56576C11.5647 8.16073 10.5961 10.0854 11.1845 11.8719L13.3033 18.306C13.7642 19.7054 15.071 20.6509 16.5442 20.6509H22.0414L24.9999 19.0874L27.9583 20.6509H33.4555C34.9287 20.6509 36.2357 19.7053 36.6964 18.306L38.8153 11.8719C39.4037 10.0853 38.4352 8.16073 36.6508 7.56576Z"
        fill="white"
      />
      <path
        d="M25.0002 5.73779C24.7481 5.73779 24.4966 5.74031 24.2457 5.74504V8.82592C24.2457 9.24262 24.5835 9.58045 25.0002 9.58045C25.4169 9.58045 25.7548 9.24262 25.7548 8.82592V5.74494C25.5038 5.74031 25.2523 5.73779 25.0002 5.73779Z"
        fill="#423E4F"
      />
      <path
        d="M15.7566 6.89669L16.5826 9.74719C16.6995 10.1508 17.1205 10.377 17.5173 10.2619C17.9176 10.1459 18.148 9.72737 18.032 9.32717L17.2204 6.52637C16.7253 6.62959 16.2348 6.74267 15.7493 6.8657C15.7519 6.87607 15.7536 6.88643 15.7566 6.89669Z"
        fill="#423E4F"
      />
      <path
        d="M34.2507 6.8657C33.7652 6.74266 33.2747 6.62949 32.7796 6.52637L31.968 9.32717C31.852 9.72747 32.0825 10.1459 32.4827 10.2619C32.8817 10.3776 33.3011 10.1486 33.4174 9.74719L34.2433 6.89669C34.2464 6.88643 34.2481 6.87607 34.2507 6.8657Z"
        fill="#423E4F"
      />
      <path
        d="M26.0366 13.2422C25.9142 12.7701 25.488 12.4404 25.0003 12.4404C24.5126 12.4404 24.0864 12.7701 23.964 13.2422L22.0418 20.6514H27.9587L26.0366 13.2422Z"
        fill="#F7931E"
      />
    </SvgIcon>
  );
};

export default ScaleIcon;
